import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ResponsiveContext } from "./Context/Responsive/Responsive";
import { BrowserRouter } from "react-router-dom";
import { MainContextProvider } from "./Context/MainContext/MainContext";
import { Provider } from "react-redux";
import storeData from "./Redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ResponsiveContext>
    <Provider store={storeData}>
      <MainContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MainContextProvider>
    </Provider>
  </ResponsiveContext>
);

reportWebVitals();
